var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadWithBorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16340",
    "data-name": "Rectangle 16340",
    width: 12.155,
    height: 12.148,
    fill: "#313131"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15736",
    "data-name": "Group 15736",
    transform: "translate(-980 4837)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15107",
    "data-name": "Group 15107",
    transform: "translate(980 -4836.818)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_628",
    "data-name": "Ellipse 628",
    transform: "translate(0 -0.182)",
    fill: "none",
    stroke: "#313131",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15550",
    "data-name": "Group 15550",
    transform: "translate(7.216 6.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15550-2",
    "data-name": "Group 15550",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41279",
    "data-name": "Path 41279",
    d: "M57.934,6.6v-.16q0-2.835,0-5.669A.759.759,0,1,1,59.453.761q0,1.483,0,2.965V6.6c.047-.044.079-.071.108-.1.425-.425.847-.853,1.276-1.274A.76.76,0,1,1,61.9,6.315q-.786.79-1.576,1.577-.524.524-1.049,1.048a.764.764,0,0,1-1.161,0L55.489,6.317a.745.745,0,0,1-.212-.77.712.712,0,0,1,.554-.528.749.749,0,0,1,.736.223q.628.63,1.258,1.258c.03.03.061.057.11.1",
    transform: "translate(-52.619 0)",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41280",
    "data-name": "Path 41280",
    d: "M6.081,223.664q2.652,0,5.3,0a.759.759,0,1,1,.006,1.517c-.49,0-.981,0-1.471,0H.783a.759.759,0,1,1-.029-1.518c.629,0,1.258,0,1.886,0H6.081",
    transform: "translate(0 -213.035)",
    fill: "#313131"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadWithBorder);
export default __webpack_public_path__ + "static/media/download-with-border.610ab654d783411c062b808efdf47315.svg";
export { ForwardRef as ReactComponent };